import { render, staticRenderFns } from "./HallOfFame.vue?vue&type=template&id=ad68820c&scoped=true&"
import script from "./HallOfFame.vue?vue&type=script&lang=js&"
export * from "./HallOfFame.vue?vue&type=script&lang=js&"
import style0 from "./HallOfFame.vue?vue&type=style&index=0&id=ad68820c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad68820c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
